import { render } from "./owner_messages.html?vue&type=template&id=62412f92&external"
import script from "./owner_messages.js?vue&type=script&lang=js&external"
export * from "./owner_messages.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__